import posthog from 'posthog-js';

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  try {
    posthog.capture(eventName, properties);
    console.debug('[PostHog] Event captured:', eventName, properties);
  } catch (e) {
    console.warn('[PostHog] Failed to capture event:', eventName, e);
  }
};

export const setUserProperties = (properties: Record<string, any>) => {
  try {
    posthog.people.set(properties);
  } catch (e) {
    console.warn('[PostHog] Failed to set user properties:', e);
  }
};

export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  try {
    posthog.identify(userId, properties);
    console.debug('[PostHog] User identified:', userId);
  } catch (e) {
    console.warn('[PostHog] Failed to identify user:', e);
  }
};

export const resetUser = () => {
  try {
    posthog.reset();
  } catch (e) {
    console.warn('[PostHog] Failed to reset user:', e);
  }
};

export const trackMapEvent = {
  addLayer: (brandName?: string) =>
    trackEvent('map_layer_added', { brand_name: brandName }),
  editLayer: (layerId?: string) =>
    trackEvent('map_layer_edited', { layer_id: layerId }),
  deleteLayer: (layerId?: string) =>
    trackEvent('map_layer_deleted', { layer_id: layerId }),
  toggleLayerVisibility: (layerId?: string, visible?: boolean) =>
    trackEvent('map_layer_visibility_toggled', { layer_id: layerId, visible }),
  viewStreetView: (lat?: number, lng?: number) =>
    trackEvent('street_view_opened', { latitude: lat, longitude: lng }),
  zoomChanged: (zoomLevel?: number) =>
    trackEvent('map_zoom_changed', { zoom_level: zoomLevel }),
};

export const trackStoreEvent = {
  viewStoreDetails: (storeName?: string, storeId?: string) =>
    trackEvent('store_details_viewed', { store_name: storeName, store_id: storeId }),
  filterStores: (filterType?: string, filterValue?: string) =>
    trackEvent('stores_filtered', { filter_type: filterType, filter_value: filterValue }),
  exportStores: (count?: number) =>
    trackEvent('stores_exported', { store_count: count }),
  searchStores: (searchQuery?: string) =>
    trackEvent('stores_searched', { search_query: searchQuery }),
};

export const trackCrmEvent = {
  opportunityCreated: (customer?: string, estRevenue?: number, storeCount?: number) =>
    trackEvent('crm_opportunity_created', { customer, est_revenue: estRevenue, store_count: storeCount }),
  opportunityCreateFailed: (customer?: string, errorMessage?: string) =>
    trackEvent('crm_opportunity_create_failed', { customer, error_message: errorMessage }),
};

export const trackAuthEvent = {
  verificationCodeSent: (email?: string) => {
    trackEvent('verification_code_sent', { email_domain: email?.split('@')[1] });
  },
  verificationCodeResent: (email?: string) => {
    trackEvent('verification_code_resent', { email_domain: email?.split('@')[1] });
  },
  verificationCodeSubmitted: (success?: boolean) => {
    trackEvent('verification_code_submitted', { success });
  },
  userLoggedIn: (userId?: string, email?: string) => {
    trackEvent('user_logged_in', { user_id: userId, email_domain: email?.split('@')[1], login_method: 'email_verification' });
  },
  loginFailed: (reason?: string) => {
    trackEvent('login_failed', { reason });
  },
  userLoggedOut: () => {
    trackEvent('user_logged_out');
  },
};
